import {MyRatingVo} from '../../common/shared/api/gateway/viewer/MyRatingVo.interface';
import {MyRating} from '../generated/types';

export function createMyRating({my_rating}: MyRatingVo): MyRating {
  return {
    myRating: my_rating,
  };
}
